import { getFrontendConfigValue, logOutIntercomUser } from '@arnold/common';
import cookies from 'js-cookie';

export const ACCESS_TOKEN_PARAM = 'accessToken';
const USER_EMAIL_COOKIE = 'userEmail';
const INTERCOM_HASH_COOKIE = 'intercomHash';
const USER_ID_COOKIE = 'userId';
const SSO_SESSION_COOKIE = 'sso_session';

const COOKIE_DOMAIN = getFrontendConfigValue('COOKIE_DOMAIN') || 'arnold-robot.com';
const SHARED_COOKIE_OPTIONS = { path: '/', domain: COOKIE_DOMAIN, expires: 60 };

class Auth {
  getIntercomHash() {
    return cookies.get(INTERCOM_HASH_COOKIE);
  }

  getUserId() {
    return cookies.get(USER_ID_COOKIE);
  }

  getUserEmail() {
    return cookies.get(USER_EMAIL_COOKIE);
  }

  setUserEmail(email: string) {
    cookies.set(USER_EMAIL_COOKIE, email, SHARED_COOKIE_OPTIONS);
  }

  isLoggedIn() {
    const userId = this.getUserId();
    return userId != null;
  }

  isSsoSession() {
    return cookies.get(SSO_SESSION_COOKIE) === 'true';
  }

  setSsoSession(isSso: boolean) {
    if (isSso) {
      cookies.set(SSO_SESSION_COOKIE, 'true', SHARED_COOKIE_OPTIONS);
    } else {
      cookies.remove(SSO_SESSION_COOKIE, SHARED_COOKIE_OPTIONS);
    }
  }

  async logout() {
    // We only clear the Arnold session - logging the user out of their SSO
    // identity provider (e.g. their whole Microsoft account) is not desired.
    this.removeUserCookies();

    await fetch(getFrontendConfigValue('API_URL') + '/auth/session', {
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      method: 'DELETE',
      credentials: 'include',
    }).catch((err) => {
      // We don't care about the result. If this fails, server will have stale session but
      // it's server's business only and client doesn't care
    });

    logOutIntercomUser();

    return true;
  }

  removeUserCookies() {
    cookies.remove(INTERCOM_HASH_COOKIE, SHARED_COOKIE_OPTIONS);
    cookies.remove(USER_ID_COOKIE, SHARED_COOKIE_OPTIONS);
    this.setSsoSession(false);
  }

  redirectToLogin(email?: string, redirectToOverviewAfterLogin = false) {
    if (email) {
      this.setUserEmail(email);
    }
    const adminUrl = getFrontendConfigValue('SELF_CARE_URL') ?? 'https://admin.arnold-robot.com';
    const loginBaseUrl = `${adminUrl}/login`;
    if (redirectToOverviewAfterLogin) {
      window.location.href = `${loginBaseUrl}?redirect=${window.location.origin}/overview`;
    } else {
      const currentUrl = window.location.href;
      let loginUrl = `${loginBaseUrl}?redirect=${encodeURIComponent(currentUrl)}`;

      const search = window.location.search;
      if (search) {
        const urlSearchParams = new URLSearchParams(search);
        const source = urlSearchParams.get('utm_source');
        if (source) {
          loginUrl = `${loginUrl}&utm_source=${encodeURIComponent(source)}`;
        }
      }
      window.location.href = loginUrl;
    }
  }
}

const auth = new Auth();
export default auth;
